import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { fetchRatingSummary } from "@/lib/api";

// Read-only average rating display (genuine data only). Renders nothing when
// there are no ratings yet — never shows a fabricated or empty score.
export const CityRating = () => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchRatingSummary()
      .then((s) => { if (!cancelled) setSummary(s); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!summary || !summary.count || summary.count < 1) return null;
  const full = Math.round(summary.average);

  return (
    <div className="mt-4 flex items-center gap-2" data-testid="city-rating" aria-label={`Note moyenne ${summary.average} sur 5`}>
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} className={"h-4 w-4 " + (i <= full ? "fill-primary text-primary" : "text-muted-foreground/40")} />
        ))}
      </div>
      <span className="text-sm text-muted-foreground">
        <strong className="text-foreground">{summary.average.toFixed(1)}</strong>/5 · {summary.count} avis
      </span>
    </div>
  );
};
